<template>
<div :class="[{'columns is-variable is-6': !column_superseded}, {'is-mobile': !is_mobile}]">
    <div :class="{'column is-4': !column_superseded}">
        <router-link v-if="item.cta.button.is_interal" :to="item.cta.button.url" class="is-block">
            <figure v-if="item.image">
                <img :alt="item.image.title" :src="item.image.url" />
            </figure>
        </router-link>
        <a v-else :href="item.cta.button.url" :target="item.cta.button.open_in_blank ? '_blank' : null" class="is-block">
            <figure v-if="item.image">
                <img :alt="item.image.title" :src="item.image.url" />
            </figure>
        </a>
    </div>
    <div :class="{'column is-8': !column_superseded}">
        <h3 :class="['title', item.title_colour]">{{item.title}}</h3>
        <div ref="content" class="content" v-html="item.content"></div>
        <div class="cta" v-if="item.cta">
            <router-link :class="['button', {'is-rounded': item.cta.config.rounded}, item.cta.config.colour, item.cta.config.size]" v-if="item.cta.button.is_internal" :target="item.cta.button.open_in_blank ? '_blank' : null" :to="item.cta.button.url">{{item.cta.button.title}}</router-link>
            <a :class="['button', {'is-rounded': item.cta.config.rounded}, item.cta.config.colour, item.cta.config.size]" v-else :href="item.cta.button.url" :target="item.cta.button.open_in_blank ? '_blank' : null">{{item.cta.button.title}}</a>
        </div>
    </div>
</div>
</template>

<script>
import WindowResizeHandler from '@/components/mixins/WindowResizeHandler';
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name        :   'Webinar',
    props       :   ['item'],
    mixins      :   [ WindowResizeHandler, ViewBlockItemMixin ],
    data()
    {
        return {
            is_mobile   :   false
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods :   {
        handle_window_resize(width)
        {
            this.is_mobile  =   width <= 640;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/Webinar.vue